export default function getWeekDay(date, month, mod, year, context) {
  if (!date) {
    return 'N/A'
  }

  if(mod == "short"){
    Date.weekDays = context.$t('shortWeekDays');
  }else {
    Date.weekDays = context.$t('weekDays');
  }

  if(date < 10){
    date = "0"+date;
  }
  var dtt = new Date(year+'/'+month+'/'+date);
  return  Date.weekDays[dtt.getDay()];
}


// WEBPACK FOOTER //
// ./src/app/filters/getWeekDay.js